import { Action, createReducer, on } from '@ngrx/store';
import { StateBuilder } from '../../../model/state.builder';
import { DemographyActions } from './demography.actions';
import { IDemographyState } from './demography.state';

export const initialDemographyState: IDemographyState = {
  model: undefined,
  data: undefined,
  uiState: undefined
};

const demographyReducerFn = createReducer(
  initialDemographyState,
  on(DemographyActions.reset, (state: IDemographyState, action) => {
    return new StateBuilder<IDemographyState>(initialDemographyState).build();
  }),
  on(DemographyActions.load, (state: IDemographyState) => {
    return new StateBuilder<IDemographyState>(state).toLoading().build();
  }),
  on(DemographyActions.loadSuccess, (state: IDemographyState, action) => {
    return new StateBuilder<IDemographyState>(state, action).toLoaded().build();
  }),
  on(DemographyActions.submit, (state: IDemographyState) => {
    return new StateBuilder<IDemographyState>(state).toLoading().build();
  }),
  on(DemographyActions.submitSuccess, (state: IDemographyState, action) => {
    return new StateBuilder<IDemographyState>(state, action).toLoaded().build();
  })
);

export function demographyReducer(state: IDemographyState | undefined, action: Action) {
  return demographyReducerFn(state, action);
}
